import { SentryConfigOptions } from '@/composables';
import { FeatureFlagKey } from '@/features';

export type Configuration = {
  cognito?: {
    userPoolId: string;
    userPoolClientId: string;
  };
  portalApi: string;
  portalEwaBffApi: string;
  mapbox: {
    token?: string;
    overlaysTileSet?: string;
    overlayTileSetLayers?: {
      dfesRegions: string;
      lga: string;
      lgaCentres: string;
      pastoralStations: string;
    };
  };
  remoteHazardAssets: {
    iconAssetsPathSvg: string;
    iconAssetsPathPng: string;
  };
  geospatialBucket: string;
  windTileBaseUrl: string;
  externalTileBaseUrl: string;
  webTemplateStyleSheetUrl: string;
  sentry?: SentryConfigOptions;
  environment: Environment;
  featureFlags?: Partial<Record<FeatureFlagKey, boolean>>;
  firebaseConfig?: {
    appId: string;
    apiKey: string;
    projectId: string;
    authDomain: string;
    storageBucket: string;
    messagingSenderId: string;
    measurementId?: string;
  };
  recaptcha?: {
    siteKey: string;
    enabled?: boolean;
  };
  googleTagManager: {
    containerId: string;
  };
};

export type Environment = (typeof ENVIRONMENTS)[number];

export const ENVIRONMENTS = [
  'local',
  'dev',
  'uat',
  'preflight',
  'preflight-uat',
  'preflight-dev',
  'prd-gv',
  'prd-training',
  'prd',
] as const;
export const DEFAULT_ENVIRONMENT: Environment = 'prd';
export const CLIENT_APP = 'ewa';
export const PARTITION_KEY = 'x-gv-client';

export const HOSTNAMES_TO_ENVIRONMENTS: Record<string, Environment> = {
  // !Production hostnames. Please DO NOT TOUCH these unless you know what you are doing.
  // !Refer to the infra/cfg/au-prd-config.ts.

  // Phase 1
  'emergency.wa.gov.au': 'prd',
  'www.emergency.wa.gov.au': 'prd',

  'training.ewa.wa.gov.au': 'prd-training',
  'www.training.ewa.wa.gov.au': 'prd-training',

  'emergencywa.genvis.com': 'prd-gv',
  'www.emergencywa.genvis.com': 'prd-gv',

  // !Preflight hostnames.
  'ewa.preflight.portal.genvis.com': 'preflight',
  'www.ewa.preflight.portal.genvis.com': 'preflight',

  'uat.ewa.wa.gov.au': 'preflight-uat',
  'www.uat.ewa.wa.gov.au': 'preflight-uat',

  'dev.ewa.wa.gov.au': 'preflight-dev',
  'www.dev.ewa.wa.gov.au': 'preflight-dev',

  // !UAT hostnames.
  'ewa.uat.portal.genvis.com': 'uat',
  'www.ewa.uat.portal.genvis.com': 'uat',

  // !Development hostnames.
  'ewa.dev.portal.genvis.com': 'dev',
  'www.ewa.dev.portal.genvis.com': 'dev',

  // !Local hostnames.
  localhost: 'local',
};
